import React from 'react';
import OwnerStatisticsPage from './OwnerStatisticsPage';

const StatisticsPage: React.FC = () => {
  return <OwnerStatisticsPage />;
};

export default StatisticsPage;